import { cn } from "@babybjorn/ui";
import type { StoryblokRichTextNode } from "@storyblok/react";
import type { FC, PropsWithChildren, ReactElement } from "react";
import RichText from "../general/RichText";
import * as s from "./Text.module.scss";

type TextProps = PropsWithChildren<{
	textAlignLeft?: boolean | null;
	label?: string | null;
	headline: string | null;
	content: string | StoryblokRichTextNode<ReactElement> | null;
}>;

const Text: FC<TextProps> = ({
	textAlignLeft,
	label,
	headline,
	content,
	children,
}) => (
	<section className={cn(s.container, { [s.center]: !textAlignLeft })}>
		{(headline || label) && (
			<header className={s.header}>
				{label && <p className={s.label}>{label}</p>}
				{headline && <h2 className={s.headline}>{headline}</h2>}
			</header>
		)}
		<div className={s.content}>
			{content && <RichText content={content} />}
			<div className={s.buttonContainer}>{children}</div>
		</div>
	</section>
);

export default Text;
